export const RequestStatus = {
    Requested: 1,
    InProgress: 2,
    Completed: 3,
    Error: 4,
    Cancelled: 5
};

Object.freeze(RequestStatus);